module.exports = __webpack_public_path__ + "media/packs/site/assets/images/title-93ec9d7a1806e8a25d1331d89a4940c1.svg";